<card-default
  [title]="(bondName | translate) + ' ' + ('FORM_LABEL.BOND_REQUEST' | translate) + ' ' + bondRequest.referenceNumber"
  [style]="cardStyle"
  [showFooter]="false"
  [ngClass]="bondClassName"
>
  <div *ngIf="(canView || canEdit || canDelete) && !isCustomState" header-action>
    <dropdown-action [menuMode]="menuMode" *ngIf="canView || canEdit || canDelete" className="m-0">
      <button dropdown-item *ngIf="canView" class="dropdown-item" [routerLink]="['/companies', 'bond-request', 'view']">
        {{ "BUTTON.VIEW" | translate }}
      </button>
      <button dropdown-item *ngIf="canEdit" class="dropdown-item" [routerLink]="['/companies', 'bond-request', 'edit']">
        {{ "BUTTON.EDIT" | translate }}
      </button>
      <button dropdown-item *ngIf="canDelete" class="dropdown-item" (click)="checkPayment()">{{ "BUTTON.DELETE" | translate }}</button>
    </dropdown-action>
  </div>
  <div>
    <div class="row mb-1">
      <div class="col-6 label">{{ "LABELS.CREATED_DATE" | translate }}</div>
      <div class="col-6 value">{{ bondRequest.createdDate | customDateByUtc }}</div>
    </div>
    <div class="row mb-1">
      <div class="col-6 label">{{ "FORM_LABEL.STATE" | translate }}</div>
      <div class="col-6 value">{{ bondRequest | bondRequestState | translate }}</div>
    </div>
    <ng-template [ngIf]="!isCustomState" [ngIfElse]="description">
      <div class="row">
        <div class="col-6 label">{{ "LABELS.PAYMENT_STATE" | translate }}</div>
        <div class="col-6 value">{{ bondPaymentStateName | translate }}</div>
      </div>
    </ng-template>
    <ng-template #description>
      <div class="row">
        <div class="col-6 label">{{ "LABELS.DESCRIPTION" | translate }}</div>
        <div class="col-6 value">{{ bondRequest.customState.description }}</div>
      </div>
    </ng-template>
  </div>
</card-default>

<custom-modal [(open)]="openDeleteModal" [header]="'LABELS.DELETE_BOND_REQUEST'" [type]="'error'">
  <div>{{ "DELETE_PAID_BOND_REQUEST" | translate }}</div>
  <button footer-action type="button" class="btn btn-primary" (click)="onDecline()">
    {{ "BUTTON.NO_KEEP_IT" | translate | uppercase }}
  </button>
  <button footer-action type="button" class="btn btn-secondary" (click)="onDelete()">
    {{ "BUTTON.YES_DELETE" | translate | uppercase }}
  </button>
</custom-modal>
